import { AfterViewChecked, AfterViewInit, Component, OnInit } from '@angular/core';
import { TicketBase } from '../ticket-base';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { TicketService } from 'src/app/services/ticket.service';
import { UserService } from 'src/app/services/user.service';
import { NotificationService } from 'src/app/services/notification.service';
import { BonusService } from 'src/app/services/bonus.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { FreeBetService } from 'src/app/services/freeBet.service';
import { ModelMapperService } from 'src/app/services/util/model.mapper.service';
import { StorageService } from 'src/app/services/util/storage.service';
import { TicketProviderService } from 'src/app/services/providers/ticket.provider.service';
import { ITicket } from 'src/app/models/ticket/ticket.interface';
import { ITicketGroup } from 'src/app/models/ticket/ticketGroup.interface';
import { TicketType, FreeBetProcessingType } from 'src/app/models/enums';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { SettingsService } from 'src/app/services/settings.service';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';

@Component({
  selector: 'app-ticket-single',
  templateUrl: './ticket-single.component.html',
  styleUrls: ['./ticket-single.component.less']
})
export class TicketSingleComponent extends TicketBase implements AfterViewInit {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  CV = ConstantValues;

  constructor(
    ticketService: TicketService,
    userService: UserService,
    notificationService: NotificationService,
    bonusService: BonusService,
    utilityService: UtilityService,
    public freeBetService: FreeBetService,
    modelMapper: ModelMapperService,
    storage: StorageService,
    settingsService: SettingsService,
    authentificationService: AuthenticationService) {
    super(ticketService, userService, notificationService, bonusService, utilityService, freeBetService, modelMapper, storage, settingsService, authentificationService);
  }

  protected onTicketChanged(changed: boolean, recalculateOddsForSysOpts: boolean = false) {
    if (this.orderingForTicketItemGroups.length === 0) {
      this.resetCalculatedValues();
    } else {
      let bets = 1;
      for (const order of this.orderingForTicketItemGroups) {
        bets *= order.outcomeIds.length;
      }
      this.ticketData.numberOfBets = bets;

      this.calculateOddAndWinings();
    }

    this.ticketService.updateTicketData(this.ticketData);
  }


  protected calculateOddAndWinings() {
    const td = this.ticketService.calculateOddAndWiningsTicketFix(
      this.oddsMap,
      this.minOddsMap,
      this.ticketData.totalStake,
      this.wagerPerBet,
      this.ticketData.numberOfBets,
      this.freeBetService.playerFreeBetSettings,
      this.freeBetBalance,
      this.bonusService.playerBonussSettings,
      this.bonusService.bonussSettings,
      this.orderingForTicketItemGroups,
      this.ticketData.payin,
      this.ticketData.taxBeforeStake);

    this.ticketData.totalWinings = td.totalWinings;
    this.ticketData.minWinings = td.minWinings;
    this.ticketData.totalOdd = td.totalOdd;
    this.ticketData.minOdd = td.minOdd;
    this.ticketData.possibleWin = td.possibleWin;
    this.ticketData.bonus = td.bonus;
    this.ticketData.bonusPercent = td.bonusPercent;
    this.ticketData.freeBetValue = td.freeBetValue;
    this.ticketData.freeBetValueToShow = td.freeBetValueToShow;
    this.ticketData.taxOnWinings = td.taxOnWinings;
    this.ticketData.possibleWinWithoutTax = td.possibleWinWithoutTax;
    this.ticketData.possibleMinPayout = td.possibleMinPayout;
    this.ticketData.taxOnMinWinning = td.taxOnMinWinning;
  }

  protected openTicketConfirm(){
    this.ticketService.openTicketConfirmation(this.oddsValidationMode, this.ticketData, true);
  }


  private resetCalculatedValues() {
    this.ticketData.possibleWin = 0;
    this.ticketData.totalOdd = 0;
    this.ticketData.numberOfBets = 0;
    this.ticketData.totalWinings = 0;
    this.ticketData.bonus = 0;
    this.ticketData.bonusPercent = 0;
    this.ticketData.minOdd = 0;
    this.ticketData.minWinings = 0;
    this.ticketData.freeBetValue = 0;
    this.ticketData.taxOnWinings = 0;
    this.ticketData.possibleWinWithoutTax = 0;
    this.ticketData.possibleMinPayout = 0;
    this.ticketData.taxOnMinWinning = 0;
    this.mobileTotalOdd.emit(this.ticketData.totalOdd);
  }

  protected createTicket(): ITicket {
    return this.ticketService.createTicketFix(this.ticketData.freeBetValue, this.freeBetService.playerFreeBetSettings, this.orderingForTicketItemGroups, this.ticketItemGroups, this.ticketData);
  }

  protected calculateFreeBet() {
    const freebets = this.ticketService.calculateFreeBet(this.freeBetService.playerFreeBetSettings,
      this.freeBetBalance,
      this.ticketData.numberOfBets,
      this.orderingForTicketItemGroups,
      this.wagerPerBet,
      this.ticketData.totalOdd,
      this.ticketData.totalWinings,
      this.ticketData.bonus,
      this.ticketData.totalStake);

    this.ticketData.freeBetValue = freebets.freeBetValue;
    this.ticketData.freeBetValueToShow = freebets.freeBetValueToShow;
  }

  ngAfterViewInit(): void {
    this.payinInputField = document.getElementById('totalStakeInput') as HTMLInputElement;
  }

}
